import posthog from 'posthog-js'
import type { App, Plugin } from 'vue'

export const PosthogPlugin: Plugin = {
  install(app: App) {
    app.config.globalProperties.$posthog = posthog.init(import.meta.env.VITE_POSTHOG_TOKEN, {
      api_host: 'https://us.i.posthog.com',
    })
  },
}

export default PosthogPlugin
